import api from './authService';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

export const vendorPrivateBookingApi = {
  list: async (params = {}) => {
    const response = await api.get('/vendor/bookings', {
      params: { booking_source: 'vendor_manual', per_page: 100, ...params },
    });
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/vendor/bookings/manual', data);
    return response.data;
  },

  update: async ({ id, data }) => {
    const response = await api.put(`/vendor/bookings/manual/${id}`, data);
    return response.data;
  },

  remove: async (id) => {
    const response = await api.delete(`/vendor/bookings/manual/${id}`);
    return response.data;
  },

  createInvoice: async (bookingId, payload = {}) => {
    const response = await api.post(`/vendor/invoices/from-booking/${bookingId}`, payload);
    return response.data;
  },
};

export const useVendorPrivateBookings = (params = {}, options = {}) => {
  return useQuery({
    queryKey: ['vendorPrivateBookings', params],
    queryFn: () => vendorPrivateBookingApi.list(params),
    staleTime: 60 * 1000,
    ...options,
  });
};

export const useCreateVendorPrivateBooking = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: vendorPrivateBookingApi.create,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['vendorPrivateBookings'] });
      queryClient.invalidateQueries({ queryKey: ['vendorBookings'] });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
};

export const useUpdateVendorPrivateBooking = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: vendorPrivateBookingApi.update,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['vendorPrivateBookings'] });
      queryClient.invalidateQueries({ queryKey: ['vendorBookings'] });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
};

export const useDeleteVendorPrivateBooking = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: vendorPrivateBookingApi.remove,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['vendorPrivateBookings'] });
      queryClient.invalidateQueries({ queryKey: ['vendorBookings'] });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
};

export const useCreatePrivateBookingInvoice = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ bookingId, payload }) =>
      vendorPrivateBookingApi.createInvoice(bookingId, payload),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['vendor-invoices'] });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
};
